export const productFaqFields = ['faqs'];
